import { useMemo } from 'react';
import { useWindowDimensions } from 'react-native';
import { CONTENT_WIDE_BREAKPOINT } from '../../shared/layout/breakpoints';

/** Informes > Ventas: mismo corte en filtros, buscador y rejilla KPI. */
export const REPORTS_VENTAS_WIDE_BREAKPOINT = CONTENT_WIDE_BREAKPOINT;

/** Buscador unificado: ícono catálogo solo texto en pantallas muy angostas. */
export const REPORTS_VENTAS_COMPACT_SEARCH_BREAKPOINT = 400;

export type ReportsVentasLayoutMode = {
  layoutWide: boolean;
  searchCompact: boolean;
  catalogIconOnly: boolean;
  catalogLabel: string;
  scanShowIcon: boolean;
};

export function getReportsVentasLayoutMode(width: number): ReportsVentasLayoutMode {
  const layoutWide = width >= REPORTS_VENTAS_WIDE_BREAKPOINT;
  const searchCompact = width < REPORTS_VENTAS_COMPACT_SEARCH_BREAKPOINT;

  return {
    layoutWide,
    searchCompact,
    catalogIconOnly: searchCompact,
    catalogLabel: layoutWide ? 'Catálogo' : 'Cat.',
    scanShowIcon: !searchCompact,
  };
}

export function useReportsVentasLayout() {
  const { width } = useWindowDimensions();
  return useMemo(() => ({ width, ...getReportsVentasLayoutMode(width) }), [width]);
}
